<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";

// Custom Components
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Pagination from "../Pagination.vue";
import handleLogic from "@/helpers/handleLogic";

export default {
  data() {
    return {
      selectedRoomData: null,
      table: {
        tableData: [],
        size: 100,
        next: null,
        previous: null,
        currentPage: 0,
      },
      selectDate: moment().format("YYYY-MM-DD"),
      isLoading: false,
      keyData: null,
    };
  },
  props: {
    currentProps: Object,
  },
  components: {
    DatePicker,
    Pagination,
  },
  mounted() {
    this.selectedRoomData = this.currentProps.data;
    this.keyData = this.currentProps.selectedKey;
    this.getDeviceBasedLogList(`?size=${this.table.size}`);
  },
  methods: {
    // Method is used to get device based key logs
    async getDeviceBasedLogList(query) {
      const filter =
        `/${this.selectedRoomData.lock_iot_device.id}` +
        query +
        "&iot_key=" +
        this.keyData.id;
      this.isLoading = true;
      try {
        const response = await UserService.getKeyLogList(filter);
        if (response) {
          this.table.tableData = [];
          this.table.previous = response.previous;
          this.table.next = response.next;
          this.table.currentPage = response.page_number;
          response.results.map((item) => {
            this.handleResponse(item);
          });
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to get more guest
    onPageChange(page) {
      this.getDeviceBasedLogList(`?page=${page}&size=100`, "load_more");
    },
    // Method is used to handle response
    handleResponse(item) {
      if (item.topic == "ALARM" || item.topic == "CMD") {
        const data = handleLogic.handleGatewaySocketResponse(item);
        this.table.tableData.push(data);
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xl-9 col-lg-8">
        <div class="card">
          <div class="p-3">
            <div class="row justify-content-end">
              <div class="col-xl-2 col-sm-3 col-6">
                <date-picker
                  lang="en"
                  class="mb-2"
                  placeholder="Select Date"
                  type="date"
                  value-type="format"
                  v-model="selectDate"
                ></date-picker>
              </div>
            </div>
            <div class="table-responsive">
              <v-table
                :data="table.tableData"
                class="table table-hover mb-0"
                ref="my-table"
              >
                <thead class="table-light" slot="head">
                  <tr>
                    <th class="w-25">timestamp</th>
                    <th class="w-25">Events</th>
                    <th class="w-25">User</th>
                    <th class="w-25">Remark</th>
                  </tr>
                </thead>
                <tbody
                  class="infinite-list"
                  slot="body"
                  slot-scope="{ displayData }"
                  v-if="!isLoading && table.tableData.length !== 0"
                >
                  <tr v-for="(log, index) in displayData" :key="index">
                    <td>
                      {{
                        global_format_date_and_time_custom(
                          log.created_at,
                          "YYYY-MM-DD hh:mm a"
                        )
                      }}
                    </td>
                    <td>
                      {{ log.event }}
                    </td>
                    <td class="text-capitalize">{{ log.user_type }}</td>
                    <td v-if="log.remark !== '-'">
                      <div v-html="log.remark"></div>
                    </td>
                    <td v-else>-</td>
                  </tr>
                </tbody>
                <tbody slot="body" v-else-if="isLoading">
                  <tr v-for="item in 10" :key="item">
                    <td class="placeholder-glow" v-for="no in 4" :key="no">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                  </tr>
                </tbody>
                <tbody slot="body" v-else>
                  <tr>
                    <td colspan="9" class="text-center">
                      <img
                        src="@/assets/images/empty.svg"
                        class="img-fluid"
                        alt=""
                      />
                      <p>
                        <span class="text-secondary">No Data Found</span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </v-table>
              <Pagination
                v-if="table.previous !== null || table.next !== null"
                :totalPages="table.totalPages"
                :currentPage="table.currentPage"
                @pagechanged="onPageChange"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-4">
        <div class="card">
          <div class="p-3">
            <div class="row" v-if="keyData !== null">
              <div class="col-sm-6">
                <div class="mb-4">
                  <h6 class="fw-bold">Key :</h6>
                  <p class="mb-0 text-uppercase">{{ keyData.key_type }}</p>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <h6 class="fw-bold">Key Number</h6>
                  <p class="mb-0">{{ keyData.rfid_card_id }}</p>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <h6 class="fw-bold">Key Holder Name:</h6>
                  <p class="mb-0">
                    {{
                      keyData.booking !== null
                        ? keyData.booking.first_name
                        : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <h6 class="fw-bold">Key Type</h6>
                  <p class="mb-0 text-capitalize">
                    {{ keyData.user_levey_type }}
                  </p>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <h6 class="fw-bold">Key Code:</h6>
                  <p class="mb-0">
                    {{ keyData.key_code !== null ? keyData.key_code : "-" }}
                  </p>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <h6 class="fw-bold">Total Usage</h6>
                  <p class="mb-0">
                    {{ keyData.total_usage }}
                  </p>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <h6 class="fw-bold">Issue Date:</h6>
                  <p class="mb-0">
                    {{
                      global_format_date_and_time_custom(
                        keyData.start_datetime,
                        "DD-MM-YYYY hh:mm"
                      )
                    }}
                  </p>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <h6 class="fw-bold">Valid Upto:</h6>
                  <p class="mb-0">
                    {{
                      global_format_date_and_time_custom(
                        keyData.expire_datetime,
                        "DD-MM-YYYY hh:mm"
                      )
                    }}
                  </p>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <h6 class="fw-bold">Nights:</h6>
                  <p class="mb-0">
                    {{
                      keyData.booking !== null
                        ? keyData.booking.stay_night
                        : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <h6 class="fw-bold">Floor Access:</h6>
                  <p class="mb-0">All</p>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <h6 class="fw-bold">Assigned To:</h6>
                  <p class="mb-0">
                    {{
                      keyData.assigned_to !== null
                        ? keyData.assigned_to.first_name +
                          " " +
                          keyData.assigned_to.last_name
                        : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <h6 class="fw-bold">DeadLock Enable :</h6>
                  <p class="mb-0">
                    {{ keyData.is_deadbolt_enable ? "Yes" : "No" }}
                  </p>
                </div>
              </div>
              <div class="col-sm-12">
                <h6 class="fw-bold">Common Doors:</h6>
                <p class="mb-0">Main Door, Swimming Pool, Gym</p>
              </div>
              <div class="col-sm-12">
                <div
                  class="d-flex align-items-center justify-content-between mt-5"
                >
                  <b-dropdown
                    toggle-class="text-muted p-0"
                    menu-class="dropdown-menu-end"
                    right
                    variant="white"
                  >
                    <template v-slot:button-content>
                      <i class="mdi mdi-dots-vertical font-size-24"></i>
                    </template>
                    <b-dropdown-item>Delete Key</b-dropdown-item>
                  </b-dropdown>
                  <img
                    src="@/assets/images/rfid-key-icon.png"
                    alt="rfid-key"
                    class="d-block text-end"
                    v-if="keyData.key_type == 'rfid'"
                  />
                  <img
                    src="@/assets/images/mobile-key-icon.png"
                    alt="rfid-key"
                    class="d-block text-end"
                    v-if="keyData.key_type == 'mobile'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
